(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.popover"] && !Shopify.designMode) return;
  try {
    class KitPopover extends HTMLElement {
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      // Prevent flash of previously-positioned popover
      this.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') {
            this.style.visibility = 'hidden';
          }
        },
        { signal }
      );

      this.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.style.visibility = '';
          }
        },
        { signal }
      );

      window.addEventListener(
        'resize',
        () => {
          if (this.matches(':popover-open')) this.#position();
        },
        { signal, passive: true }
      );

      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('a[href], button:not([popovertarget])')) {
            this.hidePopover();
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #position() {
      const trigger = document.querySelector(`[popovertarget="${this.id}"]`);
      if (!trigger) return;

      const placement = this.getAttribute('placement') || 'bottom-start';
      const isRTL = getComputedStyle(this).direction === 'rtl';
      const gap = Number(this.getAttribute('gap') ?? 4);
      const margin = 4;

      const triggerRect = trigger.getBoundingClientRect();
      const popoverWidth = this.offsetWidth;
      const popoverHeight = this.offsetHeight;

      const [axis, alignment] = placement.split('-');

      let top = axis === 'bottom' ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap;
      let resolvedAxis = axis;

      // Auto-flip vertically if overflowing viewport
      if (axis === 'bottom' && top + popoverHeight > window.innerHeight - margin) {
        top = triggerRect.top - popoverHeight - gap;
        resolvedAxis = 'top';
      } else if (axis === 'top' && top < margin) {
        top = triggerRect.bottom + gap;
        resolvedAxis = 'bottom';
      }

      const alignStart = isRTL ? 'end' : 'start';
      let left;
      if (alignment === 'center') {
        left = triggerRect.left + (triggerRect.width - popoverWidth) / 2;
      } else if (alignment === alignStart) {
        left = triggerRect.left;
      } else {
        left = triggerRect.right - popoverWidth;
      }

      // Clamp horizontally to viewport
      if (left < margin) {
        left = margin;
      } else if (left + popoverWidth > window.innerWidth - margin) {
        left = window.innerWidth - popoverWidth - margin;
      }

      this.style.transformOrigin = resolvedAxis === 'bottom' ? 'top' : 'bottom';

      // Convert to document coordinates so popover scrolls with page
      this.style.top = `${Math.round(top + window.scrollY)}px`;
      this.style.left = `${Math.round(left + window.scrollX)}px`;
    }
  }

  customElements.define('kit-popover', KitPopover);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soleil-cart-protection"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.spProt) return; window.spProt = 1;
  const root = window.Shopify?.routes?.root || '/';
  const SKU = 'Insure01', HANDLE = 'shipping-protection', OPTOUT = '_protection_declined';
  // app rule: 5% of the cart, rounded up to the next $0.50, $1 min, $50 max (tiers are variants priced 1.00 to 50.00)
  const RATE = 0.05, STEP = 50, MIN = 100, MAX = 5000;
  // variant ids by price in cents; filled from Liquid, with the known id sequence as a fallback
  let map = {};
  try { const el = document.querySelector('[data-sp-prot-variants]'); if (el) map = JSON.parse(el.textContent).v || {}; } catch (e) {}
  const variantFor = cents => { const key = String(cents); if (map[key]) return map[key]; const i = Math.round((cents - 100) / 50); return 53100721340735 + i * 32768; };
  const isProt = i => i.sku === SKU || i.handle === HANDLE || i.product_type === 'ShipWill';
  const priceFor = cart => { const base = cart.items.filter(i => !isProt(i) && i.requires_shipping !== false).reduce((s, i) => s + i.final_line_price, 0); return Math.min(MAX, Math.max(MIN, Math.ceil(base * RATE / STEP) * STEP)); };
  const declined = cart => (cart.attributes || {})[OPTOUT] === '1';
  const money = (n, c) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: c || 'USD' }).format(n / 100);
  const post = (url, body) => fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(r => { if (!r.ok) throw new Error(url); return r.json(); });
  const getCart = () => fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
  let busy = false, t = 0;

  const paint = (cart, on) => {
    const prot = cart.items.find(isProt), others = cart.items.filter(i => !isProt(i) && i.requires_shipping !== false).length;
    if (on === undefined) on = others ? !declined(cart) : false;
    document.querySelectorAll('[data-sp-prot]').forEach(el => {
      el.hidden = !others || cart.currency !== 'USD';
      el.classList.toggle('is-on', on);
      el.querySelector('[data-sp-prot-input]').checked = on;
      el.querySelector('[data-sp-prot-price]').textContent = money(on && prot ? prot.final_line_price : priceFor(cart), cart.currency);
      el.querySelector('[data-sp-prot-sub]').textContent = on ? 'Lost, stolen or damaged? We replace it free.' : 'Your order is not protected';
    });
    // header and cart page counts should not include the protection line
    if (prot) document.querySelectorAll('[data-sp-cart-count]').forEach(n => { const c = cart.item_count - prot.quantity; n.textContent = c + (c === 1 ? ' item' : ' items'); });
  };

  // keep exactly one correct tier in the cart while it is wanted; none when declined or when nothing else is in the cart
  const sync = async cart => {
    const others = cart.items.some(i => !isProt(i) && i.requires_shipping !== false), target = others && !declined(cart) ? variantFor(priceFor(cart)) : null;
    const lines = cart.items.filter(isProt), updates = {};
    lines.forEach(i => { if (i.variant_id !== target || i.quantity !== 1 || lines.length > 1) updates[i.key] = 0; });
    const keep = lines.find(i => i.variant_id === target && i.quantity === 1 && lines.length === 1);
    if (!Object.keys(updates).length && (keep || !target)) return cart;
    if (Object.keys(updates).length) cart = await post('cart/update.js', { updates });
    if (target) { await post('cart/add.js', { items: [{ id: target, quantity: 1 }] }); cart = await getCart(); }
    document.dispatchEvent(new CustomEvent('cart:build'));
    if (document.querySelector('#CartPageForm')) window.location.reload();
    return cart;
  };

  const refresh = async () => {
    if (busy) return; busy = true;
    try { let cart = await getCart(); paint(cart); cart = await sync(cart); paint(cart); } catch (e) {} finally { busy = false; }
  };
  const schedule = () => { clearTimeout(t); t = setTimeout(refresh, 150); };

  document.addEventListener('change', async e => {
    const input = e.target.closest && e.target.closest('[data-sp-prot-input]'); if (!input) return;
    const want = input.checked, status = input.closest('[data-sp-prot]').querySelector('[data-sp-prot-status]');
    busy = true; document.querySelectorAll('[data-sp-prot]').forEach(b => { b.classList.add('is-busy'); b.querySelector('[data-sp-prot-status]').textContent = ''; });
    try { let cart = await getCart(); paint(cart, want); cart = await post('cart/update.js', { attributes: { [OPTOUT]: want ? '' : '1' } }); cart = await sync(cart); paint(cart); }
    catch (err) { input.checked = !want; status.textContent = 'Could not update protection. Please try again.'; }
    finally { busy = false; document.querySelectorAll('[data-sp-prot]').forEach(b => b.classList.remove('is-busy')); }
  });
  document.addEventListener('click', e => {
    const b = e.target.closest && e.target.closest('[data-sp-prot-more]'); if (!b) return;
    const panel = b.closest('[data-sp-prot]').querySelector('[data-sp-prot-panel]'), open = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', open); panel.classList.toggle('is-open', open);
  });
  ['cart:updated', 'cart:open', 'ajaxProduct:added'].forEach(n => document.addEventListener(n, schedule));
  const start = () => { document.querySelectorAll('#CartDrawer [data-products],#CartPageForm [data-products]').forEach(n => new MutationObserver(schedule).observe(n, { childList: true })); refresh(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soleil-cart-tools"] && !Shopify.designMode) return;
  try {
    (() => {
  const root=window.Shopify?.routes?.root||'/';
  let busy=false,queued=false,lastCart=null;
  const money=(n,currency)=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency||'USD'}).format(n/100);
const whole=(n,c)=>money(n,c).replace(/\.00(?=\D*$)/,'');
  // bar + truck glide to the new position; the amount counts to its new value. replay=true restarts from empty (cart just opened)
  const shipAnimate=(el,replay)=>{
    const d=el._sp;if(!d)return;
    const fill=el.querySelector('[data-shipping-fill]'),truck=el.querySelector('[data-shipping-truck]'),copy=el.querySelector('[data-shipping-copy]');
    if(replay){fill.style.transition=truck.style.transition='none';fill.style.width='0%';truck.style.left='0%';void fill.offsetWidth;fill.style.transition=truck.style.transition='';el.dataset.last=d.threshold;}
    el.classList.toggle('is-unlocked',!d.left);
    if(!d.left)copy.innerHTML=d.wheel?'<b>Free shipping unlocked</b> on your other parts':'You&rsquo;ve unlocked <b>free U.S. shipping</b>';
    const from=el.dataset.last?Number(el.dataset.last):d.threshold,to=d.left;el.dataset.last=to;
    if(d.left&&replay)copy.innerHTML='You&rsquo;re <b>'+whole(from,d.currency)+'</b> away from <b>free U.S. shipping</b>';
    // on open, wait for the panel's fade-up before the bar fills
    setTimeout(()=>{
      requestAnimationFrame(()=>requestAnimationFrame(()=>{fill.style.width=d.pct+'%';truck.style.left=d.pct+'%';}));
      if(!d.left)return;
      const t0=performance.now(),dur=from===to?0:900;
      const step=now=>{const k=dur?Math.min(1,(now-t0)/dur):1,e=1-Math.pow(1-k,3),v=Math.round((from+(to-from)*e)/100)*100;copy.innerHTML='You&rsquo;re <b>'+whole(v,d.currency)+'</b> away from <b>free U.S. shipping</b>';if(k<1)requestAnimationFrame(step);};
      requestAnimationFrame(step);
    },replay?420:0);
  };
  // replay the bar every time the cart drawer opens
  const drawer=document.getElementById('CartDrawer');
  if(drawer){let was=false;new MutationObserver(()=>{const open=drawer.classList.contains('drawer--is-open');if(open&&!was)drawer.querySelectorAll('[data-soleil-shipping]').forEach(el=>shipAnimate(el,true));was=open;}).observe(drawer,{attributes:true,attributeFilter:['class']});}
  const paint=cart=>{    lastCart=cart;
    document.querySelectorAll('[data-soleil-shipping]').forEach(el=>{
      el.hidden=el.dataset.enabled!=='true'||cart.currency!=='USD'||!cart.item_count;
      const total=Math.max(0,cart.total_price-cart.items.filter(i=>!i.requires_shipping||i.sku==='Insure01'||/^shipping-protection/.test(i.handle||'')).reduce((sum,i)=>sum+i.final_line_price,0));
      const threshold=Number(el.dataset.threshold),left=Math.max(0,threshold-total),pct=Math.min(100,total/threshold*100);
      el.querySelector('[data-shipping-bar]').setAttribute('aria-valuenow',Math.round(Math.min(total,threshold)/100));
      el._sp={pct,left,threshold,currency:cart.currency,wheel:cart.items.some(i=>/wheel-set|upgraded-adjustable-forks|sotion-fw23-72v-mid-drive-motor/i.test(i.handle||'')||/^TUT-SOL-WHEEL-SET/i.test(i.sku||''))};
      shipAnimate(el,false);
    });    document.querySelectorAll('[data-soleil-discount]').forEach(el=>{
      const code=(cart.discount_codes||[]).find(c=>c.applicable)||(cart.discount_codes||[])[0];
      const remove=el.querySelector('[data-discount-remove]');remove.hidden=!code;
      if(code){el.querySelector('[data-discount-status]').textContent=code.applicable?code.code+' — '+el.dataset.applied:el.dataset.invalid;el.classList.add('is-open');el.querySelector('[data-discount-toggle]')?.setAttribute('aria-expanded','true');}
    });
  };
  const refresh=async()=>{queued=false;try{const r=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});if(r.ok)paint(await r.json());}catch(e){}};
  const schedule=()=>{if(queued)return;queued=true;setTimeout(refresh,100)};
  const apply=async(el,remove)=>{
    if(busy)return;const input=el.querySelector('[data-discount-input]'),status=el.querySelector('[data-discount-status]');const code=remove?'':input.value.trim();
    if(!remove&&!code){status.textContent=el.dataset.empty;input.focus();return;}
    busy=true;el.querySelectorAll('button').forEach(b=>b.disabled=true);status.textContent='';
    try{
      const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:code})});
      if(!response.ok)throw new Error('cart');const cart=await response.json();paint(cart);
      const applied=(cart.discount_codes||[]).some(c=>c.applicable&&c.code.toLowerCase()===code.toLowerCase());
      status.textContent=remove?el.dataset.removed:applied?code+' — '+el.dataset.applied:el.dataset.invalid;
      if(remove||applied)input.value='';
      document.dispatchEvent(new CustomEvent('cart:build'));
      if(document.querySelector('#CartPageForm')&&(remove||applied))window.location.reload();
    }catch(e){status.textContent=el.dataset.error;}finally{busy=false;el.querySelectorAll('button').forEach(b=>b.disabled=false);}
  };
  document.addEventListener('click',event=>{const t=event.target.closest&&event.target.closest('[data-discount-toggle]');if(t){const el=t.closest('[data-soleil-discount]'),open=!el.classList.contains('is-open');el.classList.toggle('is-open',open);t.setAttribute('aria-expanded',open);if(open)setTimeout(()=>el.querySelector('[data-discount-input]')?.focus({preventScroll:true}),220);return;}});
  document.addEventListener('click',event=>{const button=event.target.closest('[data-discount-apply],[data-discount-remove]');if(button){event.preventDefault();apply(button.closest('[data-soleil-discount]'),button.hasAttribute('data-discount-remove'));}});
  document.addEventListener('keydown',event=>{if(event.key==='Enter'&&event.target.matches('[data-discount-input]')){event.preventDefault();apply(event.target.closest('[data-soleil-discount]'),false);}});
  ['cart:updated','cart:open','ajaxProduct:added'].forEach(name=>document.addEventListener(name,schedule));
  const start=()=>{document.querySelectorAll('#CartDrawer [data-products],#CartPageForm [data-products]').forEach(n=>new MutationObserver(schedule).observe(n,{childList:true,subtree:true}));refresh()};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soleil-cart-upsell"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.spUpsell) return; window.spUpsell = 1;
  const root = window.Shopify?.routes?.root || '/';
  const isProt = i => i.sku === 'Insure01' || i.handle === 'shipping-protection' || i.product_type === 'ShipWill';
  const money = (n, c) => new Intl.NumberFormat('en-US', { style: 'currency', currency: c || 'USD' }).format(n / 100).replace('.00', '');
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const cutFor = p => { const m = p.media && p.media[0]; return m ? `/cdn/shop/files/soleil-cut-${m.id}.png?width=160` : null; };
  let last = '', t = 0;
  const render = async () => {
    const boxes = document.querySelectorAll('[data-sp-upsell]'); if (!boxes.length) return;
    let cart; try { cart = await fetch(root + 'cart.js').then(r => r.json()); } catch (e) { return; }
    const count = cart.items.filter(i => !isProt(i)).reduce((s, i) => s + i.quantity, 0);
    const items = cart.items.filter(i => !isProt(i) && i.requires_shipping !== false);
    document.querySelectorAll('[data-sp-cart-count]').forEach(n => { n.textContent = count + (count === 1 ? ' item' : ' items'); n.hidden = !count; });
    if (!items.length) { boxes.forEach(b => b.hidden = true); last = ''; return; }
    // free-shipping gap (same math as soleil-cart-tools): parts that ship, minus protection
    const shipTotal = cart.items.filter(i => i.requires_shipping && !isProt(i)).reduce((s, i) => s + i.final_line_price, 0);
    const left = cart.currency === 'USD' ? Math.max(0, 30000 - shipTotal) : 0, gap = left > 0 && left <= 15000 ? left : 0;
    const inCart = new Set(items.map(i => i.product_id)), key = items[0].product_id + '|' + [...inCart].join(',') + '|' + gap;
    if (key === last) return; last = key;
    let recs = [];
    try { recs = (await fetch(`${root}recommendations/products.json?product_id=${items[0].product_id}&limit=8&intent=related`).then(r => r.json())).products || []; } catch (e) {}
    recs = recs.filter(p => p.available && !inCart.has(p.id) && !/shipping-protection|gift-card|crash-replacement/.test(p.handle));
    // owner 2026-10-11: under $300, lead with the cheapest pick that gets them to free shipping
    const unlocks = p => gap && (p.price_max || p.price) >= gap;
    const lead = gap ? recs.filter(unlocks).sort((a, b) => (a.price_min || a.price) - (b.price_min || b.price))[0] : null;
    recs = (lead ? [lead, ...recs.filter(p => p !== lead)] : recs).slice(0, 2);
    document.querySelectorAll('[data-soleil-shipping]').forEach(bar => {
      let hint = bar.querySelector('[data-sp-ship-hint]');
      if (!lead) { if (hint) hint.hidden = true; return; }
      if (!hint) { hint = document.createElement('p'); hint.className = 'scp__hint'; hint.setAttribute('data-sp-ship-hint', ''); bar.querySelector('[data-shipping-bar]').before(hint); }
      hint.innerHTML = 'Add <b>' + esc(lead.title) + '</b> below and your shipping is free.'; hint.hidden = false;
    });
    boxes.forEach(box => {
      const list = box.querySelector('[data-sp-upsell-list]');
      if (!recs.length) { box.hidden = true; return; }
      list.innerHTML = recs.map(p => {
        const v = p.variants.find(x => x.available) || p.variants[0], img = p.featured_image ? p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=160' : '';
        const cut = cutFor(p), multi = p.variants.length > 1;
        return `<div class="sp-up${unlocks(p) ? ' sp-up--ship' : ''}"><a class="sp-up__img" href="${p.url}">${img ? `<img src="${cut || img}" data-fallback="${esc(img)}" alt="" loading="lazy" onerror="if(this.dataset.fallback&&this.src.indexOf('soleil-cut')>-1){this.src=this.dataset.fallback}">` : ''}</a>` +
          `<a class="sp-up__copy" href="${p.url}"><span class="sp-up__title">${esc(p.title)}</span>${unlocks(p) ? '<span class="sp-up__ship">Unlocks free shipping</span>' : ''}<span class="sp-up__price">${multi ? 'From ' : ''}${money(p.price_min || p.price)}${p.compare_at_price_min > p.price_min ? `<s>${money(p.compare_at_price_min)}</s>` : ''}</span></a>` +
          (multi ? `<button type="button" class="sp-up__add" data-sp-up-pick aria-expanded="false"><svg class="sp-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>Add<svg class="sp-up__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></button>` : `<button type="button" class="sp-up__add" data-sp-up-add="${v.id}"><svg class="sp-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>Add</button>`) +
          (multi ? `<div class="sp-up__menu"><div class="sp-up__menu-in">${p.variants.filter(x => x.available).map(x => { const vi = x.featured_image && x.featured_image.src ? x.featured_image.src + (x.featured_image.src.includes('?') ? '&' : '?') + 'width=120' : img, vc = x.featured_media && x.featured_media.id ? `/cdn/shop/files/soleil-cut-${x.featured_media.id}.png?width=120` : cut; return `<button type="button" class="sp-up__opt" data-sp-up-add="${x.id}"><span class="sp-up__opt-img">${vc || vi ? `<img src="${esc(vc || vi)}" data-fallback="${esc(vi)}" alt="" loading="lazy" onerror="if(this.dataset.fallback&&this.src.indexOf('soleil-cut')>-1){this.src=this.dataset.fallback;this.classList.add('is-photo')}">` : ''}</span><span class="sp-up__opt-name">${esc(x.title)}</span><span class="sp-up__opt-price">${money(x.price)}</span></button>`; }).join('')}</div></div>` : '') + `</div>`;
      }).join('');
      if (box.hidden) { box.hidden = false; box.classList.remove('sp-upsell--in'); void box.offsetWidth; box.classList.add('sp-upsell--in'); }
    });
  };
  const soon = () => { clearTimeout(t); t = setTimeout(render, 200); };
  document.addEventListener('click', async e => {
    const pick = e.target.closest && e.target.closest('[data-sp-up-pick]');
    if (pick) { e.preventDefault(); const card = pick.closest('.sp-up'), open = !card.classList.contains('is-picking'); document.querySelectorAll('.sp-up.is-picking').forEach(c => { c.classList.remove('is-picking'); c.querySelector('[data-sp-up-pick]').setAttribute('aria-expanded', 'false'); }); card.classList.toggle('is-picking', open); pick.setAttribute('aria-expanded', open); return; }
    const add = e.target.closest && e.target.closest('[data-sp-up-add]');
    if (add) {
      e.preventDefault(); add.classList.add('is-busy');
      try {
        await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +add.getAttribute('data-sp-up-add'), quantity: 1 }] }) });
        add.classList.remove('is-busy');
        const card = add.closest('.sp-up'), main = card && card.querySelector('.sp-up__add');
        if (card) card.classList.remove('is-picking');
        if (main) { main.classList.add('is-done'); main.textContent = 'Added'; } else { add.classList.add('is-done'); add.textContent = 'Added'; }
        document.dispatchEvent(new CustomEvent('cart:build')); if (document.querySelector('#CartPageForm')) location.reload();
      } catch (err) { add.classList.remove('is-busy'); }
      return;
    }
    const rm = e.target.closest && e.target.closest('[data-sp-remove]');
    if (rm) {
      e.preventDefault(); const row = rm.closest('.cart__item'); if (row) row.classList.add('is-removing');
      try { await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: rm.getAttribute('data-sp-remove'), quantity: 0 }) }); } catch (err) {}
      document.dispatchEvent(new CustomEvent('cart:build')); if (document.querySelector('#CartPageForm')) location.reload();
    }
  });
  ['cart:updated', 'cart:open', 'ajaxProduct:added', 'cart:build'].forEach(n => document.addEventListener(n, soon));
  const start = () => { document.querySelectorAll('#CartDrawer [data-products],#CartPageForm [data-products]').forEach(n => new MutationObserver(soon).observe(n, { childList: true })); render(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soleil-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
  const groups = new WeakSet();
  const selector = '.variant-input-wrap';
  const initGroup = group => {
    if (groups.has(group)) return;
    groups.add(group);
    const positions = new WeakMap();
    let nextPosition = 0;
    let queued = false;
    const children = () => Array.from(group.children).filter(item => item.matches('.variant-input, option'));
    const unavailable = item => item.matches('option')
      ? item.disabled
      : Boolean(item.querySelector('input.disabled, input:disabled, label.disabled'));
    const observe = () => observer.observe(group, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'disabled']
    });
    const sort = () => {
      queued = false;
      if (!group.isConnected) return;
      const current = children();
      current.forEach(item => {
        if (!positions.has(item)) positions.set(item, nextPosition++);
      });
      const sorted = current.slice().sort((a, b) => Number(unavailable(a)) - Number(unavailable(b)) || positions.get(a) - positions.get(b));
      if (sorted.every((item, index) => item === current[index])) return;
      const focused = group.contains(document.activeElement) ? document.activeElement : null;
      const selected = group.matches('select') ? group.value : null;
      observer.disconnect();
      sorted.forEach((item, index) => {
        const atPosition = children()[index];
        if (item !== atPosition) group.insertBefore(item, atPosition || null);
      });
      if (selected !== null) group.value = selected;
      if (focused && document.activeElement !== focused) focused.focus({ preventScroll: true });
      observe();
    };
    const schedule = () => {
      if (queued) return;
      queued = true;
      queueMicrotask(sort);
    };
    const observer = new MutationObserver(schedule);
    observe();
    sort();
  };
  const scan = root => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches(selector)) initGroup(root);
    root.querySelectorAll(selector).forEach(initGroup);
  };
  const start = () => {
    scan(document);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(scan));
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

  (() => {
    let cancelPending = null;
    document.addEventListener('click', event => {
      const button = event.target.closest('.quick-product__btn');
      if (!button || !button.classList.contains('btn--not-ready')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (cancelPending) cancelPending();
      const card = button.closest('.grid-product');
      const productLink = card && card.querySelector('.grid-product__link');
      if (!productLink) return;

      let timeout;
      const cleanup = () => {
        observer.disconnect();
        clearTimeout(timeout);
        button.removeAttribute('aria-busy');
        cancelPending = null;
      };
      const observer = new MutationObserver(() => {
        if (button.classList.contains('btn--not-ready')) return;
        cleanup();
        if (button.isConnected) button.click();
      });
      button.setAttribute('aria-busy', 'true');
      observer.observe(button, { attributes: true, attributeFilter: ['class'] });
      cancelPending = cleanup;
      timeout = setTimeout(() => {
        cleanup();
        if (button.isConnected) window.location.assign(productLink.href);
      }, 8000);
      card.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
    }, true);
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && cancelPending) cancelPending();
    });
    window.addEventListener('pagehide', () => {
      if (cancelPending) cancelPending();
    });
  })();

  (() => {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    const reveal = (root) => {
      root.querySelectorAll('.section-header').forEach(element => {
        if (element.classList.contains('soleil-reveal')) return;
        element.classList.add('soleil-reveal');
        observer.observe(element);
      });
      root.querySelectorAll('.template-index .grid--uniform > .grid__item > .grid-product__content, .template-index .hero__text-content').forEach((element, index) => {
        if (element.classList.contains('soleil-motion')) return;
        element.style.setProperty('--soleil-delay', `${(index % 4) * 65}ms`);
        element.classList.add('soleil-motion');
        observer.observe(element);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => reveal(document), { once: true });
    else reveal(document);
    document.addEventListener('shopify:section:load', event => reveal(event.target));
  })();

  (() => {
    const tag = 'section-store--addons-block--selector-options';
    const hosts = new WeakSet();
    const menuCSS = `
:host(.active) .body{animation:soleil-menu-open 240ms ease-out both;transform-origin:top}
@keyframes soleil-menu-open{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:translateY(0)}}
@media(prefers-reduced-motion:reduce){:host(.active) .body{animation:none}}
      :host { z-index: 50; max-width: calc(100vw - 24px); }
      .body {
        background: #111 !important; color: #f7f7f7 !important;
        border: 1px solid #414141 !important; border-radius: 0 !important;
        min-width: min(220px, calc(100vw - 24px));
        max-height: var(--soleil-menu-height, 320px);
        overflow-y: auto !important; overscroll-behavior: contain;
        scrollbar-width: thin; scrollbar-color: #666 #181818;
        box-shadow: 0 12px 28px #0008; color-scheme: dark;
      }
      .option { box-sizing: border-box; min-height: 52px; padding: 10px 12px; color: #f7f7f7; transition: background-color 140ms ease; }
      .option + .option { border-top: 1px solid #272727; }
      .option:hover { background: #252525 !important; }
      .option.disabled { color: #999; opacity: 1; }
      .option.disabled:hover { background: transparent !important; }
      .option-details { padding-left: 0; }
      .variant-title { font-size: 13px; line-height: 1.4; }
      .variant-price { color: #bcbcbc; margin-top: 3px; }
      @media (prefers-reduced-motion: reduce) { .option { transition: none; } }
    `;
    const place = host => {
      if (!host.isConnected || !host.classList.contains('active')) return;
      const block = Array.from(document.querySelectorAll('section-store--product-addons-block'))
        .find(el => el.dataset.blockId === host.dataset.blockId);
      const box = block?.shadowRoot?.querySelector('.addons-box[data-product-id="' + host.dataset.productId + '"]');
      const trigger = box?.querySelector('.product-variant-selector button');
      if (!trigger) return;
      const rect = trigger.getBoundingClientRect();
      const viewport = document.documentElement.clientHeight;
      const below = viewport - rect.bottom - 18;
      const above = rect.top - 18;
      const opensAbove = below < Math.min(260, above);
      const room = Math.max(80, Math.min(320, opensAbove ? above : below));
      host.style.setProperty('--soleil-menu-height', room + 'px');
      const height = host.getBoundingClientRect().height;
      const width = host.getBoundingClientRect().width;
      const left = Math.max(12, Math.min(rect.left, document.documentElement.clientWidth - width - 12));
      const top = opensAbove ? Math.max(12, rect.top - height - 6) : rect.bottom + 6;
      host.style.left = (left + window.scrollX) + 'px';
      host.style.top = (top + window.scrollY) + 'px';
    };
    const enhance = host => {
      if (hosts.has(host) || !host.shadowRoot) return;
      hosts.add(host);
      const style = document.createElement('style');
      style.dataset.soleilAddonsMenu = '';
      style.textContent = menuCSS;
      host.shadowRoot.append(style);
      new MutationObserver(() => requestAnimationFrame(() => place(host)))
        .observe(host, { attributes: true, attributeFilter: ['class'] });
      requestAnimationFrame(() => place(host));
    };
    customElements.whenDefined(tag).then(() => {
      document.querySelectorAll(tag).forEach(enhance);
      new MutationObserver(records => {
        for (const record of records) for (const node of record.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches(tag)) enhance(node);
          node.querySelectorAll(tag).forEach(enhance);
        }
      }).observe(document.body, { childList: true, subtree: true });
      let queued = false;
      const reposition = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          document.querySelectorAll(tag + '.active').forEach(place);
        });
      };
      window.addEventListener('resize', reposition, { passive: true });
      window.addEventListener('scroll', reposition, { passive: true });
    });
  })();


  (() => {
    const selector = 'button.restock-rocket-button-product';
    const matchThemeButton = root => {
      if (!(root instanceof Element) && root !== document) return;
      if (root instanceof Element && root.matches(selector)) root.classList.add('btn', 'btn--full');
      root.querySelectorAll(selector).forEach(button => button.classList.add('btn', 'btn--full'));
    };
    const start = () => {
      matchThemeButton(document);
      new MutationObserver(records => {
        records.forEach(record => record.addedNodes.forEach(matchThemeButton));
      }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();


  (() => {
    const boundButtons = new WeakSet();
    const boundStock = new WeakSet();
    const boundSelects = new WeakSet();
    const model = () => {
      const node = document.getElementById('soleil-restock-data');
      if (!node) return null;
      try { return JSON.parse(node.textContent); } catch { return null; }
    };
    const enhanceButton = button => {
      if (boundButtons.has(button)) return;
      boundButtons.add(button);
      const sheen = document.createElement('span');
      sheen.className = 'soleil-notify-sheen';
      sheen.setAttribute('aria-hidden', 'true');
      button.append(sheen);
      const ambient = document.createElement('span');
      ambient.className = 'soleil-notify-ambient';
      ambient.setAttribute('aria-hidden', 'true');
      button.append(ambient);
      const hoverArea = button.closest('.restock-rocket-button-container') || button;
      let animation;
      const enter = () => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        button.setAttribute('data-soleil-active', '');
        animation?.cancel();
        animation = sheen.animate([{ left: '150%' }, { left: '-200%' }], {
          duration: 750, easing: 'cubic-bezier(.01,.56,1,1)'
        });
      };
      const leave = () => {
        if (!hoverArea.matches(':hover') && !button.matches(':focus-visible')) button.removeAttribute('data-soleil-active');
      };
      hoverArea.addEventListener('pointerenter', enter);
      hoverArea.addEventListener('pointerleave', leave);
      button.addEventListener('focus', enter);
      button.addEventListener('blur', leave);
    };
    const enhanceStock = root => {
      if (boundStock.has(root)) return;
      const label = root.querySelector('[data-product-inventory]');
      const button = root.querySelector('.product-single__form [data-add-to-cart]');
      if (!label || !button) return;
      boundStock.add(root);
      const row = label.closest('.sales-point');
      label.setAttribute('aria-live', 'polite');
      let previous = label.textContent.trim();
      let queued = false;
      let entrance;
      let ghost;
      const sync = () => {
        queued = false;
        const selectedId = root.querySelector('select[name="id"]')?.value || root.querySelector('input[name="id"]')?.value;
        const inventoryNode = Array.from(root.querySelectorAll('.js-variant-inventory-data')).find(node => node.dataset.id === String(selectedId));
        const quantity = inventoryNode ? Number(inventoryNode.dataset.quantity) : window.inventories?.[root.dataset.productId]?.[selectedId]?.quantity;
        let selectedVariant;
        try { selectedVariant = JSON.parse(root.querySelector('[data-variant-json]')?.textContent || '[]').find(variant => String(variant.id) === String(selectedId)); } catch {}
        const unavailable = selectedVariant ? !selectedVariant.available : inventoryNode ? quantity <= 0 && inventoryNode.dataset.policy !== 'continue' : button.disabled && Boolean(root.querySelector('select[name="id"] option:checked'));
        row.dataset.stockLevel = unavailable ? 'out' : Number.isFinite(quantity) && quantity > 0 && quantity <= 10 ? 'low' : 'healthy';
        label.closest('.icon-and-text')?.classList.toggle('inventory--low',row.dataset.stockLevel === 'low');
        row.classList.toggle('soleil-stock-out', unavailable);
        root.querySelectorAll('.soleil-dispatch-badge').forEach(badge=>badge.hidden=unavailable);
        if (unavailable) {
          const text = label.dataset.outOfStock || model()?.outOfStock;
          if (text && label.textContent !== text) label.textContent = text;
        }
        if (!unavailable) {
          const wanted = row.dataset.stockLevel === 'low' ? 'Low stock — '+quantity+' '+(quantity===1?'item':'items')+' left' : 'In stock and ready to ship';
          if(label.textContent.trim() !== wanted) label.textContent = wanted;
        }
        const remaining = !unavailable && label.textContent.match(/\b\d[\d,]*\s+items?\s+left\b/i);
        if (remaining && label.querySelector('.soleil-stock-count')?.textContent !== remaining[0]) {
          const current = label.textContent;
          const count = document.createElement('strong');
          count.className = 'soleil-stock-count';
          count.textContent = remaining[0];
          label.replaceChildren(document.createTextNode(current.slice(0, remaining.index)), count, document.createTextNode(current.slice(remaining.index + remaining[0].length)));
        }
        const next = label.textContent.trim();
        if (next === previous) return;
        const old = previous;
        previous = next;
        entrance?.cancel();
        ghost?.remove();
        if (!old || !next || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const parent = label.parentElement;
        const rect = label.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        ghost = document.createElement('span');
        ghost.className = 'soleil-stock-previous';
        ghost.setAttribute('aria-hidden','true');
        ghost.textContent = old;
        ghost.style.left = (rect.left-parentRect.left) + 'px';
        ghost.style.top = (rect.top-parentRect.top) + 'px';
        parent.append(ghost);
        const leaving = ghost;
        const exit = leaving.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(-7px)'}],{duration:140,easing:'ease-out',fill:'forwards'});
        exit.onfinish = () => leaving.remove();
        entrance = label.animate([{opacity:0,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:240,easing:'ease-out',fill:'backwards'});
      };
      const schedule = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(sync);
      };
      new MutationObserver(schedule).observe(button, { attributes: true, attributeFilter: ['disabled'] });
      new MutationObserver(schedule).observe(label, {childList:true,subtree:true,characterData:true});
      root.addEventListener('change', schedule);
      sync();
    };
    const enhanceSelect = select => {
      if (boundSelects.has(select)) return;
      const data = model();
      if (!data) return;
      const popup = select.closest('#formContainer');
      if (!popup) return;
      boundSelects.add(select);
      const header = popup.querySelector('#form-Header-Text');
      const description = popup.querySelector('#form-Description');
      if (header) header.textContent = data.heading;
      if (description) description.textContent = data.description;
      const details = document.createElement('details');
      details.className = 'soleil-restock-picker';
      const summary = document.createElement('summary');
      summary.setAttribute('aria-label', data.chooseOption);
      const list = document.createElement('div');
      list.className = 'soleil-restock-options';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', data.chooseOption);
      details.append(summary, list);
      select.insertAdjacentElement('afterend', details);
      select.classList.add('soleil-restock-native');
      select.setAttribute('aria-hidden', 'true');
      select.tabIndex = -1;
      const fillRow = (node, option) => {
        const variant = data.variants.find(item => String(item.id) === option.value);
        node.replaceChildren();
        const swatch = Array.from(document.querySelectorAll('.product-section .color-swatch')).find(label => label.textContent.trim() === option.textContent.trim());
        const background = swatch?.style.backgroundImage;
        const swatchImage = background?.startsWith('url(') ? background.slice(4, -1).replace(/^["']|["']$/g, '') : null;
        const imageSource = swatchImage || variant?.image;
        if (imageSource) {
          const image = document.createElement('img');
          image.src = imageSource; image.alt = ''; image.width = 48; image.height = 48;
          node.append(image);
        }
        const copy = document.createElement('span');
        copy.className = 'soleil-restock-copy';
        const name = document.createElement('span');
        name.className = 'soleil-restock-name'; name.textContent = option.textContent.trim();
        copy.append(name);
        if (variant?.price) {
          const price = document.createElement('span');
          price.className = 'soleil-restock-price'; price.textContent = variant.price;
          copy.append(price);
        }
        node.append(copy);
      };
      const render = () => {
        const options = Array.from(select.options);
        const selected = options.find(option => option.selected) || options[0];
        if (!selected) return;
        fillRow(summary, selected);
        summary.setAttribute('aria-label', data.chooseOption + ': ' + Array.from(summary.querySelectorAll('.soleil-restock-name, .soleil-restock-price')).map(node => node.textContent).join(', '));
        list.replaceChildren();
        for (const option of options) {
          const row = document.createElement('button');
          row.type = 'button'; row.className = 'soleil-restock-option';
          row.setAttribute('role', 'option');
          row.setAttribute('aria-selected', String(option.value === selected.value));
          fillRow(row, option);
          row.addEventListener('click', () => {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            render(); details.open = false; summary.focus();
          });
          list.append(row);
        }
      };
      list.addEventListener('keydown', event => {
        const options = Array.from(list.querySelectorAll('button'));
        const index = options.indexOf(document.activeElement);
        let next;
        if (event.key === 'ArrowDown') next = (index + 1) % options.length;
        if (event.key === 'ArrowUp') next = (index - 1 + options.length) % options.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = options.length - 1;
        if (next !== undefined) { event.preventDefault(); options[next]?.focus(); }
      });
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); details.open = false; summary.focus(); }
      });
      summary.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault(); details.open = true;
          list.querySelector('[aria-selected="true"]')?.focus();
        }
      });
      select.addEventListener('change', render);
      new MutationObserver(render).observe(select, { childList: true });
      render();
    };
    const scan = root => {
      if (!(root instanceof Element) && root !== document) return;
      for (const [selector, fn] of [
        ['.restock-rocket-button-product', enhanceButton],
        ['.product-section', enhanceStock],
        ['#formContainer #form-Select', enhanceSelect]
      ]) {
        if (root instanceof Element && root.matches(selector)) fn(root);
        root.querySelectorAll(selector).forEach(fn);
      }
    };
    const start = () => {
      scan(document);
      new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan)))
        .observe(document.body, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();



  (() => {
    const styled = new WeakSet();
    const css = `
      .bundle-header, .bundle-options { display:none!important; }
      .body {padding:0!important;}
      .checkbox-upsells-title {font-size:13px!important;color:#f7f7f7!important;font-weight:600!important;text-align:left!important;letter-spacing:.04em;}
      .checkbox-upsell-box {background:#111!important;color:#f7f7f7!important;border:1px solid #343434!important;border-radius:0!important;padding:12px!important;}
      .checkbox-upsell-title {font-size:14px!important;font-weight:500!important;color:#fff!important;}
      .checkbox-upsell-subtitle {font-size:12px!important;color:#bcbcbc!important;}
      .checkbox-upsell-price-discounted {font-size:14px!important;color:#fff!important;}
      .checkbox-upsell-price-original {font-size:12px!important;color:#aaa!important;}
      .checkbox-upsell-image {border-radius:0!important;object-fit:cover!important;}
      .checkbox-upsell-indicator {border-radius:3px!important;border:1px solid #777!important;background:#252525!important;color:#fff!important;}
      .checkbox-upsell-input:checked + .checkbox-upsell-box .checkbox-upsell-indicator {background:#22c55e!important;border-color:#22c55e!important;color:#050505!important;}
      .checkbox-upsell-input:focus-visible + .checkbox-upsell-box {outline:2px solid #aaa;outline-offset:2px;}
      @media(prefers-reduced-motion:no-preference){.checkbox-upsell-box{transition:background-color .2s,border-color .2s!important}.checkbox-upsell-box:hover{background:#191919!important;border-color:#666!important}}
    `;
    const scan = () => document.querySelectorAll('section-store--bundle-block').forEach(host => {
      const root = host.shadowRoot;
      if (!root || styled.has(root)) return;
      styled.add(root);
      const style = document.createElement('style');
      style.textContent = css;
      root.append(style);
      const observer = new MutationObserver(() => {if (!style.isConnected) root.append(style);});
      observer.observe(root,{childList:true});
    });
    customElements.whenDefined('section-store--bundle-block').then(() => {
      scan();
      new MutationObserver(scan).observe(document.body,{subtree:true,childList:true});
      document.addEventListener('shopify:section:load',scan);
    });
  })();


(() => {
  const observed = new WeakSet();
  const styled = new WeakSet();
  const models = () => Array.from(document.querySelectorAll('.soleil-addon-data')).flatMap(el => {try{return JSON.parse(el.textContent).products}catch{return []}});
  const variantData = id => models().flatMap(p => p.variants).find(v => String(v.id) === String(id));
  const applyImage = (node,id) => {
    const v = variantData(id);
    if(!v || (!v.image && !v.color)) return;
    let image=node.querySelector('.soleil-addon-swatch');
    if(!image){image=document.createElement('span');image.className='soleil-addon-swatch';image.setAttribute('aria-hidden','true');node.prepend(image);}
    image.style.backgroundColor=v.color || '#252525';
    image.style.backgroundImage=v.image ? 'url("'+v.image+'")' : 'none';
  };
  const baseCSS='.soleil-addon-swatch{display:inline-block;width:34px;height:34px;aspect-ratio:1;border-radius:50%;background-size:cover;background-position:center;border:1px solid #555;flex:0 0 34px}.option{align-items:center!important;gap:12px!important}.product-variant-selector button{display:flex;align-items:center;gap:8px}.product-variant-selector button .soleil-addon-swatch{width:22px;height:22px;flex-basis:22px}.product-image-link{width:84px!important;height:84px!important;flex:0 0 84px!important;overflow:hidden;border:1px solid #343434;transition:border-color 240ms ease}.product-image{width:100%!important;height:100%!important;object-fit:cover!important}.soleil-pair-offer{display:block;color:#f7f7f7;font-size:12px;line-height:1.5;margin-top:5px}.soleil-pair-offer strong{font-weight:600}.addons-box{border:1px solid #343434!important;background:#121212!important;padding:14px!important;transition:border-color 240ms ease,background-color 240ms ease}.product-image{transition:transform 240ms ease!important}.product-image-link:hover{border-color:#777}.product-image-link:hover .product-image{transform:scale(1.045)}.toggle{transition:filter 240ms ease,transform 240ms ease}.toggle:hover{filter:brightness(1.2);transform:scale(1.05)}.addons-box:hover{border-color:#555!important}.product-variant-selector button{border-color:#343434!important;background:#161616!important;color:#ddd!important}@media(max-width:480px){.product-image-link{width:72px!important;height:72px!important;flex-basis:72px!important}}';
  const syncRoot = root => {
    root.querySelectorAll('.option[data-variant-id],.product-variant-selector button[data-variant-id]').forEach(n=>applyImage(n,n.dataset.variantId));
    root.querySelectorAll('.addons-box').forEach(box=>{
      if(!['10349861437759','10642699485503','10342099091775','10529517895999'].includes(box.dataset.productId))return;
      const holder = root.host.closest('[data-product-id]');
      const mainId=holder?.dataset.productId;
      const pairs={'10642699485503':'10349861437759','10349861437759':'10642699485503','10342099091775':'10529517895999','10529517895999':'10342099091775'};if(pairs[mainId]!==box.dataset.productId)return;
      let note=box.querySelector('.soleil-pair-offer');
      if(!note){note=document.createElement('span');note.className='soleil-pair-offer';box.querySelector('.product-text')?.append(note);}
      const copy=mainId==='10642699485503'?'20% off Side Panels with Frame Guards. Applied in cart.':mainId==='10349861437759'?'Add Frame Guards for 20% off Side Panels. Applied in cart.':mainId==='10342099091775'?'10% off Front Ultra Bee Brake Kit with Rear Kit. Applied in cart.':'Add the Rear Ultra Bee Brake Kit for 10% off the Front Kit. Applied in cart.';
      if(note.textContent!==copy)note.textContent=copy;
    });
  };
  const enhanceHost = host => {
    const root=host.shadowRoot;if(!root)return;
    if(!styled.has(root)){styled.add(root);const style=document.createElement('style');style.textContent=baseCSS;root.append(style);}
    if(!observed.has(root)){
      observed.add(root);let queued=false;
      new MutationObserver(()=>{if(queued)return;queued=true;queueMicrotask(()=>{queued=false;syncRoot(root);});}).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['data-variant-id']});
    }
    syncRoot(root);
  };
  const scan = () => document.querySelectorAll('section-store--product-addons-block,section-store--addons-block--selector-options').forEach(enhanceHost);
  let scheduled=false;
  const schedule=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;scan();});};
  const start=()=>{scan();new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});let n=0;const timer=setInterval(()=>{scan();if(++n>20)clearInterval(timer);},500);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
(() => {
  const watched=new WeakSet();
  const scan=()=>document.querySelectorAll('[data-variant-color-label]').forEach(label=>{
    if(watched.has(label))return;watched.add(label);let last=label.textContent;
    new MutationObserver(()=>{const next=label.textContent;if(next===last)return;last=next;
      if(!matchMedia('(prefers-reduced-motion: reduce)').matches)label.animate([{opacity:0,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:240,easing:'ease-out'});
    }).observe(label,{childList:true,subtree:true,characterData:true});
  });
  scan();document.addEventListener('shopify:section:load',scan);document.addEventListener('quickview:loaded',scan);
})();
(() => {
  // Lifts the chat button above the sticky add-to-cart bar. Runs only while that bar or the chat changes, and writes
  // the variable only when the value moves (writing it every scroll frame restyled the whole page on phones).
  const observed=new WeakSet();let frame=0,until=0,last=null,scanT=0;
  const setLift=v=>{if(v===last)return;last=v;document.body.style.setProperty('--soleil-chat-lift',v);};
  const position=()=>{
    let lift=0;
    if(document.querySelector('shopify-chat[open],#CartDrawer.drawer--is-open')){setLift('0px');return;}
    document.querySelectorAll('.sticky-atc-wrapper').forEach(bar=>{
      const rect=bar.getBoundingClientRect();if(!rect.height||rect.top>=innerHeight)return;
      const style=getComputedStyle(bar);
      if((bar.classList.contains('sticky-atc-wrapper--visible')||Number(style.opacity)>.01)&&style.visibility!=='hidden')lift=Math.max(lift,innerHeight-rect.top-10);
    });
    setLift(Math.round(Math.max(0,lift))+'px');
  };
  const tick=()=>{position();if(performance.now()<until)frame=requestAnimationFrame(tick);else frame=0;};
  const sync=()=>{until=performance.now()+350;if(!frame)frame=requestAnimationFrame(tick);};
  const scan=()=>{scanT=0;document.querySelectorAll('shopify-chat').forEach(chat=>{if(observed.has(chat))return;observed.add(chat);new MutationObserver(sync).observe(chat,{attributes:true,attributeFilter:['open']});});document.querySelectorAll('.sticky-atc-wrapper').forEach(bar=>{if(observed.has(bar))return;observed.add(bar);new MutationObserver(sync).observe(bar,{attributes:true,attributeFilter:['class','style']});new ResizeObserver(sync).observe(bar);bar.addEventListener('transitionrun',sync);bar.addEventListener('transitionend',sync);sync();});};
  new MutationObserver(()=>{if(!scanT)scanT=setTimeout(scan,400);}).observe(document.body,{childList:true,subtree:true});
  addEventListener('resize',sync);scan();
})();
(() => {
 // Notify me (Restock Rocket) saves the email on the input's change event: commit it the moment the button is pressed,
 // and let Enter / "Go" on the phone keyboard send the form (its button isn't a real submit button).
 const commit=()=>{const i=document.getElementById('form-Email');if(i)i.dispatchEvent(new Event('change',{bubbles:true}));};
 document.addEventListener('pointerdown',e=>{if(e.target.closest&&e.target.closest('#formContainer #form-Button'))commit();},true);
 document.addEventListener('keydown',e=>{if(e.key!=='Enter'||!e.target||e.target.id!=='form-Email')return;e.preventDefault();commit();setTimeout(()=>{const b=document.getElementById('form-Button');if(b&&!b.disabled)b.click();},60);},true);
})();
(() => {
 const tidy=root=>{
   const success=root.matches?.('#form-Success-Text')?root:root.querySelector?.('#form-Success-Text');
   if(success && !success.dataset.soleilStyled){success.dataset.soleilStyled='true';success.textContent="We'll email you when your selected option is back in stock.";
    const container=success.closest('#formContainer');
    const heading=document.createElement('h2');heading.className='soleil-notify-success-title';heading.id='soleil-notify-success-title';heading.textContent="You're on the list";success.before(heading);
    const close=document.createElement('button');close.type='button';close.className='btn soleil-notify-close';close.textContent='Close';close.addEventListener('click',()=>container?.querySelector('#formContainer-Close')?.click());success.after(close);
    container?.setAttribute('aria-labelledby',heading.id);container?.setAttribute('aria-describedby','form-Success-Text');
    requestAnimationFrame(()=>close.focus({preventScroll:true}));}
 };
 new MutationObserver(records=>records.forEach(r=>r.addedNodes.forEach(tidy))).observe(document.body,{childList:true,subtree:true});
})();




(() => {
 const seen=new WeakSet();
 const scan=()=>document.querySelectorAll('[data-add-to-cart]').forEach(button=>{
  const label=button.querySelector('[data-add-to-cart-text]');
  if(!label||seen.has(label))return;
  seen.add(label);
  let previous=label.textContent.trim(),animation=null,outgoing=null;
  new MutationObserver(()=>{
   const next=label.textContent.trim();
   if(next===previous)return;
   const old=previous;previous=next;
   animation?.cancel();outgoing?.remove();
   if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
   outgoing=document.createElement('span');outgoing.className='soleil-atc-outgoing';outgoing.setAttribute('aria-hidden','true');outgoing.textContent=old;button.append(outgoing);
   const leaving=outgoing;
   leaving.animate([{opacity:1},{opacity:0}],{duration:120,easing:'ease-out',fill:'forwards'}).finished.then(()=>leaving.remove()).catch(()=>{});
   animation=label.animate([{opacity:0},{opacity:0,offset:.5},{opacity:1}],{duration:280,easing:'ease-out'});
   const area=button.closest('.payment-buttons');
   if(area){area.dataset.soleilFadeStart=String(document.timeline.currentTime);area.dataset.soleilFadeSold=String(button.disabled);animation.startTime=Number(area.dataset.soleilFadeStart);}

  }).observe(label,{childList:true,characterData:true,subtree:true});
 });
 scan();document.addEventListener('shopify:section:load',scan);document.addEventListener('quickview:loaded',scan);
 new MutationObserver(scan).observe(document.body,{childList:true,subtree:true});
})();


(() => {
 const animated=new WeakMap();
 const sync=()=>document.querySelectorAll('.payment-buttons[data-soleil-fade-start]').forEach(area=>{
  const start=Number(area.dataset.soleilFadeStart),sold=area.dataset.soleilFadeSold==='true';
  const target=area.querySelector(sold?'.restock-rocket-button-container':'.shopify-payment-button');
  if(!target||animated.get(target)===start)return;
  animated.set(target,start);
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  target.getAnimations().filter(a=>a.id==='soleil-purchase-sync').forEach(a=>a.cancel());
  const fade=target.animate([{filter:'opacity(0)'},{filter:'opacity(0)',offset:.5},{filter:'opacity(1)'}],{duration:280,easing:'ease-out',id:'soleil-purchase-sync'});
  fade.startTime=start;
 });
 new MutationObserver(sync).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['data-soleil-fade-start']});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soleil-mobile-conversion"] && !Shopify.designMode) return;
  try {
    (() => {
 const reduce=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
 const swatchSamples=new Map(),sampledSwatches=new WeakMap();
 const edgeColor=(url,size)=>{
  const key=url+'|'+size;if(swatchSamples.has(key))return swatchSamples.get(key);
  const sample=new Promise(resolve=>{
   const image=new Image();image.crossOrigin='anonymous';image.decoding='async';
   image.onload=()=>{try{
    const canvas=document.createElement('canvas');canvas.width=canvas.height=64;const context=canvas.getContext('2d',{willReadFrequently:true});
    const percent=/^([\d.]+)%/.exec(size),scale=percent?64*Number(percent[1])/100/image.naturalWidth:Math.max(64/image.naturalWidth,64/image.naturalHeight);
    const width=image.naturalWidth*scale,height=image.naturalHeight*scale;context.drawImage(image,(64-width)/2,(64-height)/2,width,height);
    const pixels=context.getImageData(0,0,64,64).data,buckets=new Map(),chromatic=[],hues=new Map();let sampled=0;
    for(let y=0;y<64;y++)for(let x=0;x<64;x++){
     const radius=Math.hypot(x+.5-32,y+.5-32)/32;if(radius<.82||radius>.94)continue;
     const index=(y*64+x)*4;if(pixels[index+3]<192)continue;
     const r=pixels[index],g=pixels[index+1],b=pixels[index+2],key=[r>>5,g>>5,b>>5].join(','),weight=1-Math.abs(radius-.89)*3;sampled++;
     const bucket=buckets.get(key)||{weight:0,r:0,g:0,b:0};bucket.weight+=weight;bucket.r+=r*weight;bucket.g+=g*weight;bucket.b+=b*weight;buckets.set(key,bucket);
     const max=Math.max(r,g,b),min=Math.min(r,g,b),chroma=max-min;
     if(max>=40&&chroma>=14&&chroma/max>.22){
      let hue=max===r?(g-b)/chroma:max===g?2+(b-r)/chroma:4+(r-g)/chroma;hue=(hue*60+360)%360;
      const influence=weight*Math.pow(chroma/255,.8)*Math.sqrt(max/255),bin=Math.floor(hue/20);
      chromatic.push({r,g,b,hue,weight:influence});hues.set(bin,(hues.get(bin)||0)+influence);
     }
    }
    const dominant=[...buckets.values()].sort((a,b)=>b.weight-a.weight)[0];if(!dominant){resolve(null);return;}
    const average=group=>{const total=group.reduce((sum,p)=>sum+p.weight,0);return ['r','g','b'].map(c=>Math.round(group.reduce((sum,p)=>sum+p[c]*p.weight,0)/total));};
    const rgb=color=>'rgb('+color.join(',')+')',distance=(a,b)=>Math.min(Math.abs(a-b),360-Math.abs(a-b));
    const visible=color=>{const max=Math.max(...color),min=Math.min(...color);if(max-min<14)return color.map(c=>Math.max(66,c));const gain=Math.max(1,145/max);return color.map(c=>Math.min(255,Math.round(c*gain)));};
    let primary=['r','g','b'].map(c=>Math.round(dominant[c]/dominant.weight)),secondary=primary,twoTone=false;
    if(chromatic.length>=Math.max(5,sampled*.01)){
     const ranked=[...hues.entries()].sort((a,b)=>b[1]-a[1]),mainHue=ranked[0][0]*20+10;
     primary=average(chromatic.filter(p=>distance(p.hue,mainHue)<=28));secondary=primary;
     const alternate=ranked.find(([bin,weight])=>distance(bin*20+10,mainHue)>=40&&weight>=ranked[0][1]*.22);
     if(alternate){secondary=average(chromatic.filter(p=>distance(p.hue,alternate[0]*20+10)<=24));twoTone=true;}
    }
    resolve({color:rgb(primary),glow:rgb(visible(primary)),secondary:rgb(visible(secondary)),offset:twoTone?'3px':'0px',strength:Math.min(...primary)>215?.68:1});
   }catch{resolve(null)}};image.onerror=()=>resolve(null);image.src=url;
  });swatchSamples.set(key,sample);return sample;
 };
 const enhanceSwatchGlows=()=>document.querySelectorAll('.variant-input-wrap label.color-swatch').forEach(label=>{
  if(label.__spGlowDone)return;
  const surface=label.querySelector('.soleil-swatch-surface')||label;if(surface!==label)label.__spGlowDone=true;
  const style=getComputedStyle(surface),match=/^url\(["']?(.*?)["']?\)$/.exec(style.backgroundImage);if(!match)return;
  const key=match[1]+'|'+style.backgroundSize;if(sampledSwatches.get(label)===key)return;sampledSwatches.set(label,key);
  edgeColor(match[1],style.backgroundSize).then(sample=>{if(!label.isConnected||sampledSwatches.get(label)!==key)return;label.dataset.soleilGlowSource=sample?'image-edge':'assigned-color-fallback';if(sample){label.style.setProperty('--soleil-swatch-color',sample.color);label.style.setProperty('--soleil-edge-glow',sample.glow);label.style.setProperty('--soleil-edge-glow-secondary',sample.secondary);label.style.setProperty('--soleil-glow-offset',sample.offset);label.style.setProperty('--soleil-glow-strength',sample.strength);}});
 });
 const ratingWidgets=new WeakSet();
 const enhanceRatings=()=>document.querySelectorAll('.product-single__meta .loox-rating').forEach(widget=>{
  if(ratingWidgets.has(widget))return;ratingWidgets.add(widget);
  const summary=document.createElement('a');summary.className='soleil-review-summary';summary.href='#looxReviews';summary.hidden=true;widget.after(summary);
  summary.addEventListener('click',event=>{const target=document.querySelector('#looxReviews,#looxReviewsFrame');if(target){event.preventDefault();target.scrollIntoView({behavior:reduce()?'auto':'smooth',block:'start'});}});
  const update=()=>{const rating=Number(widget.dataset.rating),count=Number(widget.dataset.raters);if(!(rating>0&&rating<=5&&Number.isInteger(count)&&count>0)){summary.hidden=true;widget.classList.remove('soleil-rating-replaced');return;}
   const key=rating+'|'+count;if(summary.dataset.value===key)return;summary.dataset.value=key;
   const stars=document.createElement('span');stars.className='soleil-review-summary__stars';stars.setAttribute('aria-hidden','true');
   for(let index=0;index<5;index++){
    const star=document.createElementNS('http://www.w3.org/2000/svg','svg');star.setAttribute('viewBox','0 0 24 24');star.classList.add('soleil-review-summary__star');star.style.setProperty('--star-delay',index*160+'ms');star.style.setProperty('--star-empty',(100-Math.max(0,Math.min(1,rating-index))*100)+'%');
    const base=document.createElementNS('http://www.w3.org/2000/svg','path');base.setAttribute('d','M12 2.5 14.94 8.46 21.52 9.42 16.76 14.06 17.88 20.61 12 17.52 6.12 20.61 7.24 14.06 2.48 9.42 9.06 8.46Z');base.classList.add('soleil-review-summary__star-base');
    const fill=base.cloneNode();fill.setAttribute('class','soleil-review-summary__star-fill');star.append(base,fill);stars.append(star);
   }
   const score=document.createElement('span');score.className='soleil-review-summary__score';score.textContent=rating.toLocaleString(undefined,{maximumFractionDigits:2})+' / 5 stars';
   const total=document.createElement('span');total.className='soleil-review-summary__count';total.textContent=count.toLocaleString()+(count===1?' review':' reviews');summary.replaceChildren(stars,score,total);summary.setAttribute('aria-label',rating+' out of 5 stars, '+count+' reviews. Read reviews');summary.hidden=false;widget.classList.add('soleil-rating-replaced');
  };update();new MutationObserver(update).observe(widget,{attributes:true,attributeFilter:['data-rating','data-raters']});
 });
 const decorate=()=>{
  enhanceSwatchGlows();
  document.querySelectorAll('section-store--product-addons-block,section-store--addons-block--selector-options,section-store--sticky-atc-block,loox-video-slider-widget,shopify-chat').forEach(host=>{
   const root=host.shadowRoot;if(!root||root.querySelector('#soleil-action-glow'))return;
   const style=document.createElement('style');style.id='soleil-action-glow';style.textContent=':is(button,[role="button"],[role="switch"]):not(:disabled):not([aria-disabled="true"]):focus-visible{filter:drop-shadow(0 0 5px #ffffff30)}@media(hover:hover){:is(button,[role="button"],[role="switch"]):not(:disabled):not([aria-disabled="true"]):hover{filter:drop-shadow(0 0 5px #ffffff30)}}';root.append(style);
  });
  enhanceRatings();
  document.querySelectorAll('section-store--benefits-list-block').forEach(host=>{const root=host.shadowRoot;if(!root||root.querySelector('#soleil-mobile-benefit-align'))return;const style=document.createElement('style');style.id='soleil-mobile-benefit-align';style.textContent='.list{align-items:flex-start;gap:6px!important}.item{box-sizing:border-box;width:fit-content;max-width:100%;padding:6px 9px;gap:7px;border:1px solid #303030;border-radius:0;background:#121212;justify-content:flex-start!important}.text{min-width:0}.text *{text-align:left!important;font-size:12px!important;line-height:1.4!important;font-weight:500;color:#dedede}.icon{flex-shrink:0;width:13px!important;min-width:13px!important;height:13px!important;opacity:.85}';root.append(style);});
  document.querySelectorAll('loox-video-slider-widget').forEach(host=>{
   const root=host.shadowRoot;if(!root||root.querySelector('#soleil-review-motion'))return;
   const style=document.createElement('style');style.id='soleil-review-motion';style.textContent='.swiper-wrapper{transition-timing-function:cubic-bezier(.22,.68,.2,1)!important}.swiper-slide-inner{scale:.76;opacity:1;transition:scale 800ms cubic-bezier(.22,.68,.2,1)!important}.swiper-slide-prev .swiper-slide-inner,.swiper-slide-next .swiper-slide-inner{scale:.88}.swiper-slide-active .swiper-slide-inner{scale:1}.swiper .video-slide,.swiper .video-slide:hover,.swiper-slide-active .video-slide{border:0!important;outline:0!important;box-shadow:none!important;background:transparent!important}.slide-play-icon{display:none!important}.navigation-button.navigation-button,.navigation-button.navigation-button:hover{background:transparent!important;border:0!important;box-shadow:none!important;color:#fff!important}.navigation-button .lxs-icon{filter:drop-shadow(0 1px 3px #0009)}.viewport{pointer-events:none}.video-slide:not(.playing-video) .slide-poster{opacity:1!important}.swiper-slide-inner .slide-poster img{object-fit:cover!important}@media(prefers-reduced-motion:reduce){.swiper-slide-inner{transition:none!important}}';root.append(style);
   const mute=()=>root.querySelectorAll('video').forEach(video=>{video.defaultMuted=true;if(!video.muted)video.muted=true;video.playsInline=true;});mute();
   root.addEventListener('play',mute,true);new MutationObserver(mute).observe(root,{childList:true,subtree:true});
  });
  document.querySelectorAll('loox-video-slider-widget').forEach(host=>{const root=host.shadowRoot;if(!root||root.querySelector('#soleil-star-sweep'))return;const s=document.createElement('style');s.id='soleil-star-sweep';s.textContent='.rating,.rating svg{animation:none!important;filter:none!important;text-shadow:none!important}';root.append(s);});
 };
 ['loox-video-slider-widget','section-store--benefits-list-block','section-store--product-addons-block','section-store--sticky-atc-block','section-store--addons-block--selector-options','shopify-chat'].forEach(name=>customElements.whenDefined(name).then(()=>{decorate();let n=0;const timer=setInterval(()=>{decorate();if(++n===20)clearInterval(timer)},500)}));
 let scheduled=false;
 const updateSteps=()=>{
  scheduled=false;if(innerWidth>=1024||reduce())return;
  // read every position first, then write only the items whose state flipped (no layout thrash while scrolling)
  const items=Array.from(document.querySelectorAll('[id$="__soleil_steps"] [class^="steps-item-"]')).filter(item=>/\bsteps-item-template/.test(item.className));if(!items.length)return;
  const line=innerHeight*.78,tops=items.map(item=>item.getBoundingClientRect().top);
  items.forEach((item,i)=>{
   const active=tops[i]<line;if(item.__spActive===active)return;item.__spActive=active;
   const wrap=item.querySelector('[class^="steps-item-wrap-"]');if(wrap){wrap.style.setProperty('translate',active?'0 0':'0 -20px','important');wrap.style.setProperty('opacity',active?'1':'.2','important');}
   item.querySelectorAll('[class^="steps-item-badge-"],[class^="steps-item-heading-"],[class^="steps-item-text-"],[class^="steps-item-icon-"]').forEach(el=>el.style.setProperty('opacity',active?'1':'.35','important'));
  });
 };
 const queue=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(updateSteps)}};
 document.addEventListener('scroll',queue,{passive:true,capture:true});window.addEventListener('resize',queue,{passive:true});
 const start=()=>{decorate();updateSteps()};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',start);let ratingQueued=false;new MutationObserver(()=>{if(ratingQueued)return;ratingQueued=true;setTimeout(()=>{ratingQueued=false;enhanceRatings();enhanceSwatchGlows();},250);}).observe(document.body,{childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soleil-pdp-addons"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__spAo) return; window.__spAo = true;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.addEventListener('change', e => {
    const i = e.target.closest && e.target.closest('[data-sp-ao-input]');
    if (i) i.closest('[data-sp-ao]').classList.toggle('is-on', i.checked);
  });
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]') || form.matches('[data-sp-fbt]')) return;
    const box = document.querySelector('[data-sp-ao].is-on');
    if (!box) return;
    e.preventDefault(); e.stopImmediatePropagation();
    const fd = new FormData(form), qty = Math.max(1, parseInt(fd.get('quantity') || '1', 10) || 1);
    const main = { id: +fd.get('id'), quantity: qty, properties: {} };
    for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v !== '') main.properties[m[1]] = v; }
    const items = [main, { id: +box.dataset.variant, quantity: box.dataset.matchQty === '1' ? qty : 1 }];
    const btn = form.querySelector('[type="submit"],[name="add"]'), err = box.querySelector('[data-sp-ao-err]');
    if (btn) { btn.classList.add('btn--loading'); btn.disabled = true; }
    err.hidden = true;
    try {
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
      if (document.getElementById('CartDrawer')) document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: j } }));
      else location.href = root + 'cart';
    } catch (x) {
      err.textContent = x.message; err.hidden = false;
    } finally {
      if (btn) { btn.classList.remove('btn--loading'); btn.disabled = false; }
    }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soleil-polish"] && !Shopify.designMode) return;
  try {
    (() => {
 const text=(el,value)=>{if(el&&el.textContent!==value)el.textContent=value;};
 // sticky bar turns on once the main Add to cart button has scrolled above the screen: an observer catches normal scrolling,
 // and one measurement after scrolling stops catches jumps straight past the button (no per-frame measuring)
 let buyOn=false,buyBtn=null,buyObs=null,buyT=0;
 const applyBuy=on=>{buyOn=on;document.querySelectorAll('.sticky-atc-wrapper.soleil-sticky-managed').forEach(b=>{if(b.classList.contains('soleil-sticky-on')!==on)b.classList.toggle('soleil-sticky-on',on);});};
 const checkBuy=()=>{buyT=0;if(buyBtn&&buyBtn.isConnected)applyBuy(buyBtn.getBoundingClientRect().bottom<0);};
 addEventListener('scroll',()=>{if(!buyBtn)return;clearTimeout(buyT);buyT=setTimeout(checkBuy,150);},{passive:true});
 const watchBuy=(button,bar)=>{if(bar.classList.contains('soleil-sticky-on')!==buyOn)bar.classList.toggle('soleil-sticky-on',buyOn);if(button===buyBtn||!('IntersectionObserver' in window))return;
  if(buyObs)buyObs.disconnect();buyBtn=button;
  buyObs=new IntersectionObserver(en=>{const e=en[en.length-1];if(e.target!==buyBtn||!e.target.isConnected)return;applyBuy(!e.isIntersecting&&e.boundingClientRect.bottom<0);});buyObs.observe(button);};
 const sync=()=>{
  document.querySelectorAll('.return-link svg:not([data-soleil-arrow])').forEach(svg=>{svg.dataset.soleilArrow='true';svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('fill','none');svg.setAttribute('stroke','currentColor');svg.setAttribute('stroke-width','1.7');svg.setAttribute('stroke-linecap','round');svg.setAttribute('stroke-linejoin','round');const path=document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d','M14 6l-6 6 6 6');path.setAttribute('fill','none');svg.replaceChildren(path);});
  document.querySelectorAll('template[data-soleil-nav-preview]').forEach(template=>{const link=Array.from(document.querySelectorAll('.site-navigation > li > a')).find(a=>a.getAttribute('href')===template.dataset.soleilNavPreview);if(!link||link.parentElement.classList.contains('soleil-collection-nav'))return;link.parentElement.classList.add('soleil-collection-nav');link.parentElement.append(template.content.cloneNode(true));});
  document.querySelectorAll('.product-block--price .product__policies a[href$="/policies/shipping-policy"]').forEach(link=>{const next=link.nextSibling;if(next?.nodeType===3)next.remove();const parent=link.parentElement;link.remove();if(!parent.textContent.trim())parent.remove();});
  const main=document.querySelector('.product-single__meta'),price=main?.querySelector('[data-product-price]'),root=main?.closest('[data-product-id]');
  const selected=root?.querySelector('.variant-input-wrap input:checked + .color-swatch .soleil-swatch-surface');
  document.querySelectorAll('.sticky-atc-wrapper').forEach(bar=>{
   const container=bar.querySelector('.sticky-atc-text-container');if(!container||!price)return;
   const purchase=main.querySelector('form button[data-add-to-cart]');
   if(purchase&&bar.querySelector('button[data-add-to-cart]')){if(!bar.classList.contains('soleil-sticky-managed'))bar.classList.add('soleil-sticky-managed');watchBuy(purchase,bar);}
   let value=container.querySelector('.soleil-sticky-price');if(!value){value=document.createElement('div');value.className='soleil-sticky-price';container.append(value);}{const spb=main.querySelector('.sp-spbox--auto [data-p]');if(spb){let o=value.querySelector('.sp-st-o'),n=value.querySelector('.sp-st-n');if(!o||!n){value.textContent='';o=document.createElement('span');o.className='sp-strike sp-st-o';o.setAttribute('data-sp-anim','');n=document.createElement('span');n.className='sp-st-n';n.setAttribute('data-sp-anim','');value.append(o,n);}const ot=price.textContent.trim(),nt=spb.textContent.trim();if(o.textContent!==ot)o.textContent=ot;if(n.textContent!==nt)n.textContent=nt;}else{if(value.querySelector('.sp-st-n'))value.textContent='';text(value,price.textContent.trim());}}
   const variant=container.querySelector('.sticky-atc-variant-container');if(!variant)return;
   let swatch=variant.querySelector('.soleil-sticky-swatch');
   if(selected){if(!swatch){swatch=document.createElement('span');swatch.className='soleil-sticky-swatch';swatch.setAttribute('aria-hidden','true');variant.prepend(swatch);}const style=getComputedStyle(selected),k=style.backgroundImage+'|'+style.backgroundColor+'|'+style.backgroundSize;if(swatch.dataset.k!==k){swatch.dataset.k=k;swatch.style.backgroundImage=style.backgroundImage;swatch.style.backgroundColor=style.backgroundColor;swatch.style.backgroundSize=style.backgroundSize;}}else swatch?.remove();
  });
  document.querySelectorAll('button[data-add-to-cart]').forEach(button=>{if(button.querySelector('.soleil-cart-glyph'))return;const template=document.getElementById('soleil-cart-icon-template');if(!template)return;const icon=document.createElement('span');icon.className='soleil-cart-glyph';icon.setAttribute('aria-hidden','true');icon.append(template.content.cloneNode(true));button.prepend(icon);});
 };
 let queued=false;const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;sync();});};
 const start=()=>{sync();new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,characterData:true});};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('change',schedule);
 addEventListener('resize',schedule);
 let navFrame=0,navLast='';const position=()=>{navFrame=0;const header=document.querySelector('.site-header');if(!header)return;const v=Math.round(Math.max(0,header.getBoundingClientRect().bottom))+'px';if(v!==navLast){navLast=v;document.documentElement.style.setProperty('--soleil-nav-bottom',v);}};
 const positionSoon=()=>{if(!navFrame)navFrame=requestAnimationFrame(position);};
 addEventListener('scroll',positionSoon,{passive:true});addEventListener('resize',positionSoon);position();
 document.addEventListener('keydown',event=>{if(event.key==='Escape'&&event.target.closest('.soleil-collection-nav'))event.target.blur();});
})();

(() => {
 const clean=s=>s.replace(/([.,])00(?=([^\d]|$))/g,'');
 const prices='.product__price,.grid-product__price,.cart__price,.cart__item-price-col,.cart__subtotal,.soleil-sticky-price,.soleil-related-card__price,[data-product-price],[data-subtotal],.ss-product-price,.soleil-addon-price';
 const tidy=()=>document.querySelectorAll(prices).forEach(el=>{const walker=document.createTreeWalker(el,NodeFilter.SHOW_TEXT);let node;while(node=walker.nextNode()){if(node.parentElement.closest('script,style,.soleil-price-counter'))continue;const next=clean(node.nodeValue);if(next!==node.nodeValue)node.nodeValue=next;}});
 const chat=()=>{}; /* Chat now lives on Contact Us. */

 let queued=false;const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;tidy();chat();});};
 const start=()=>{tidy();chat();new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,characterData:true});};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
(() => {
 const reduce=()=>matchMedia('(prefers-reduced-motion:reduce)').matches;
 const galleries=new WeakSet();
 const setup=()=>{
  document.querySelectorAll('.soleil-photo-collage').forEach(gallery=>{
   if(galleries.has(gallery))return;galleries.add(gallery);
   let previous=gallery.querySelector('.product-main-slide.is-selected');
   new MutationObserver(()=>{
    const next=gallery.querySelector('.product-main-slide.is-selected');
    if(!next||next===previous)return;previous=next;
    if(innerWidth>768||reduce())return;
    const image=next.querySelector('.product-image-main');if(!image)return;
    image.getAnimations().forEach(a=>a.cancel());
    image.animate([{opacity:0,translate:'22px 0'},{opacity:1,translate:'0 0'}],{duration:480,easing:'cubic-bezier(.16,1,.3,1)'});
   }).observe(gallery.querySelector('.product-slideshow'),{subtree:true,attributes:true,attributeFilter:['class']});
  });
  const targets=document.querySelectorAll('[id$="__soleil_steps"] [class^="steps-item-wrap-"],[id$="__soleil_steps"] .steps-heading-heading,[id$="__soleil_steps"] .steps-text-intro');
  if(reduce()||!('IntersectionObserver' in window))return;
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('soleil-step-visible');observer.unobserve(entry.target);}}),{threshold:.2,rootMargin:'0px 0px -15% 0px'});
  targets.forEach(el=>{if(el.classList.contains('soleil-step-reveal'))return;el.classList.add('soleil-step-reveal');observer.observe(el);});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
 document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soleil-refinements"] && !Shopify.designMode) return;
  try {
    (() => {
 const reduce=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
 const setup=()=>{
  const narrow=innerWidth<=768;
  document.querySelectorAll('.soleil-photo-collage').forEach(gallery=>{
   const active=gallery.querySelector('.product-main-slide.is-selected')||gallery.querySelector('.product-main-slide');
   const selected=active?.dataset.index,seen=new Set();let count=0;
   gallery.querySelectorAll('.product__thumb-item').forEach(tile=>{
    const link=tile.querySelector('.product__thumb'),key=link?.dataset.id||link?.href;
    const duplicate=(!narrow&&tile.dataset.index===selected)||seen.has(key);seen.add(key);
    tile.classList.toggle('soleil-photo-duplicate',duplicate);
    tile.classList.toggle('soleil-extra-photo',!duplicate&&++count>(narrow?4:8));
   });
   gallery.querySelector('[data-soleil-photos-toggle]')?.classList.toggle('soleil-no-extra',count<=(narrow?4:8));
   if(gallery.dataset.uniqueExtras!==String(count))gallery.dataset.uniqueExtras=String(count);
  });
  document.querySelectorAll('.site-header__logo-link').forEach(link=>{const img=link.querySelector('img');if(img){const v='url("'+(img.currentSrc||img.src)+'")';if(link.style.getPropertyValue('--soleil-logo-mask')!==v)link.style.setProperty('--soleil-logo-mask',v);}});
  document.querySelectorAll('.variant-input-wrap label.variant__button-label').forEach(label=>{if(!label.querySelector('.soleil-variant-glint')){const glint=document.createElement('span');glint.className='soleil-variant-glint';glint.setAttribute('aria-hidden','true');label.append(glint);}});
  document.querySelectorAll('.variant-input-wrap .color-swatch').forEach(label=>{
   if(!label.classList.contains('soleil-normalized-swatch')){
    const style=getComputedStyle(label),surface=document.createElement('span');surface.className='soleil-swatch-surface';surface.setAttribute('aria-hidden','true');surface.style.backgroundImage=style.backgroundImage;surface.style.backgroundColor=style.backgroundColor;
    if(/circle|11_26_40_PM/.test(style.backgroundImage))surface.style.backgroundSize='111%';
    label.append(surface);label.classList.add('soleil-normalized-swatch');
   }
   const input=document.getElementById(label.htmlFor),sold=label.classList.contains('disabled'),name=input?.value||label.textContent;
   const text=name+(sold?' — Out of stock':'');
   if(label.title!==text)label.title=text;
   if(input&&input.getAttribute('aria-label')!==text)input.setAttribute('aria-label',text);
  });
 };
 let queued=false;const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;setup();});};
 // only re-run for changes that touch the product photos, variant options or the header logo (not every class change on the page)
 const rel='.product-section,.site-header,.soleil-photo-collage,.variant-input-wrap';
 const relevant=records=>records.some(r=>{const t=r.target;if(r.type==='attributes')return !!(t.closest&&t.closest('.soleil-photo-collage,.variant-input-wrap'));if(t.closest&&t.closest(rel))return true;for(const n of r.addedNodes)if(n.nodeType===1&&(n.matches(rel)||n.querySelector(rel)))return true;return false;});
 const start=()=>{setup();new MutationObserver(records=>{if(!queued&&relevant(records))schedule();}).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 addEventListener('resize',schedule);
 document.addEventListener('focus',event=>{if(innerWidth>768&&event.target.matches('.soleil-photo-collage .product__thumb'))event.stopImmediatePropagation();},true);
 document.addEventListener('keydown',event=>{if(innerWidth>768&&event.key==='Enter'&&event.target.matches('.soleil-photo-collage .product__thumb'))event.stopImmediatePropagation();},true);
 document.addEventListener('click',event=>{
  const gallery=event.target.closest('.soleil-photo-collage');if(!gallery)return;
  const target=event.target.closest('.product__thumb,.product-image-main');if(!target)return;
  const thumb=target.matches('.product__thumb'),index=thumb?target.dataset.index:target.closest('.product-main-slide')?.dataset.index;
  if(thumb&&innerWidth<=768)return;
  const images=Array.from(gallery.querySelectorAll('.product__main-photos .photoswipe__image'));
  const picked=images.find(img=>img.closest('.product-main-slide')?.dataset.index===index);
  if(!picked||typeof PhotoSwipe==='undefined'||typeof PhotoSwipeUI_Default==='undefined')return;
  const shell=document.querySelector('.pswp');if(!shell)return;
  event.preventDefault();event.stopImmediatePropagation();
  const items=images.map(img=>({src:img.dataset.photoswipeSrc,w:Number(img.dataset.photoswipeWidth),h:Number(img.dataset.photoswipeHeight),msrc:img.currentSrc||img.src}));
  const zoom=new PhotoSwipe(shell,PhotoSwipeUI_Default,items,{index:images.indexOf(picked),history:false,closeOnScroll:false,shareEl:false,captionEl:false,counterEl:false,preloaderEl:false,tapToToggleControls:false,showHideOpacity:innerWidth<=768,showAnimationDuration:reduce()?0:(innerWidth<=768?480:780),hideAnimationDuration:reduce()?0:680,allowPanToNext:false,getThumbBoundsFn:i=>{if(innerWidth<=768)return undefined;const source=i===images.indexOf(picked)?target:gallery.querySelector('.product__thumb[data-index="'+images[i].closest('.product-main-slide').dataset.index+'"]');const rect=(source||target).getBoundingClientRect();return{x:rect.left,y:rect.top+window.scrollY,w:rect.width};}});
  const focused=document.activeElement,scrollPosition={x:window.scrollX,y:window.scrollY};
  const stopScroll=event=>{if(event.cancelable)event.preventDefault();};
  const stopKeys=event=>{if(['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' '].includes(event.key))event.preventDefault();};
  document.documentElement.classList.add('soleil-photo-open');
  document.addEventListener('wheel',stopScroll,{passive:false,capture:true});
  document.addEventListener('touchmove',stopScroll,{passive:false,capture:true});
  document.addEventListener('keydown',stopKeys,true);
  zoom.listen('destroy',()=>{document.documentElement.classList.remove('soleil-photo-open');document.removeEventListener('wheel',stopScroll,true);document.removeEventListener('touchmove',stopScroll,true);document.removeEventListener('keydown',stopKeys,true);window.scrollTo({left:scrollPosition.x,top:scrollPosition.y,behavior:'instant'});});
  target.classList.add('soleil-zoom-source');shell.classList.add('soleil-zoom-eased');zoom.listen('initialZoomOut',()=>shell.classList.add('soleil-zoom-closing'));zoom.listen('destroy',()=>{target.classList.remove('soleil-zoom-source');shell.classList.remove('soleil-zoom-eased','soleil-zoom-closing');focused?.focus({preventScroll:true});});zoom.init();
 },true);
 document.addEventListener('click',async event=>{
  const toggle=event.target.closest('[data-soleil-photos-toggle]');if(!toggle||toggle.dataset.animating)return;
  const gallery=toggle.closest('.soleil-photo-collage'),expand=!gallery.classList.contains('soleil-photos-expanded');
  const tiles=Array.from(gallery.querySelectorAll('.product__thumb-item')),bounds=gallery.getBoundingClientRect(),before=bounds.height,buttonBefore=toggle.getBoundingClientRect();
  const positions=new Map(tiles.map(el=>[el,el.getBoundingClientRect()]));
  const wasVisible=new Set(tiles.filter(el=>el.getBoundingClientRect().height>0));
  gallery.classList.toggle('soleil-photos-expanded',expand);
  const after=gallery.getBoundingClientRect().height;
  const changed=expand?tiles.filter(el=>!wasVisible.has(el)&&el.getBoundingClientRect().height>0):tiles.filter(el=>wasVisible.has(el)&&!el.getBoundingClientRect().height);
  toggle.dataset.animating='true';toggle.setAttribute('aria-expanded',String(expand));
  if(!toggle.dataset.originalText)toggle.dataset.originalText=toggle.textContent;
  toggle.textContent=expand?toggle.dataset.lessText:toggle.dataset.originalText;
  if(!reduce()){
   const duration=expand?400:460,easing='cubic-bezier(.22,.61,.36,1)',animations=[],ghosts=[];
   gallery.dataset.animatingPhotos='true';gallery.style.overflow='hidden';gallery.style.position='relative';
   toggle.style.position='absolute';toggle.style.left='0';toggle.style.right='0';toggle.style.bottom='0';toggle.style.height=buttonBefore.height+'px';
   if(!expand)changed.forEach(el=>{const rect=positions.get(el),ghost=el.cloneNode(true);ghost.removeAttribute('id');ghost.className='soleil-photo-exit';ghost.setAttribute('aria-hidden','true');ghost.style.cssText='position:absolute;pointer-events:none;left:'+(rect.left-bounds.left)+'px;top:'+(rect.top-bounds.top)+'px;width:'+rect.width+'px;height:'+rect.height+'px';ghost.querySelectorAll('[id]').forEach(n=>n.removeAttribute('id'));ghost.querySelectorAll('a,button').forEach(n=>n.setAttribute('tabindex','-1'));gallery.append(ghost);ghosts.push(ghost);animations.push(ghost.animate([{opacity:1,translate:'0 0'},{opacity:0,translate:'0 -12px'}],{duration:210,easing:'ease-out',fill:'forwards'}));});
   const motion=gallery.animate([{height:before+'px'},{height:after+'px'}],{duration,easing,fill:'both'});
   if(expand)changed.forEach(el=>animations.push(el.animate([{opacity:0,translate:'0 -12px'},{opacity:1,translate:'0 0'}],{duration:360,easing:'ease-out'})));
   await motion.finished.catch(()=>{});
   ghosts.forEach(el=>el.remove());animations.forEach(a=>a.cancel());motion.cancel();
  }
  gallery.style.removeProperty('overflow');gallery.style.removeProperty('position');['position','left','right','bottom','height'].forEach(p=>toggle.style.removeProperty(p));delete gallery.dataset.animatingPhotos;delete toggle.dataset.animating;
 });
 document.addEventListener('click',event=>{
  const option=event.target.closest('.soleil-related-option');if(!option)return;
  const card=option.closest('.soleil-related-card'),picker=option.closest('details'),summary=picker.querySelector('summary');
  summary.querySelector('[data-related-label]').textContent=option.dataset.title;
  const icon=summary.querySelector('.soleil-related-swatch'),source=option.querySelector('.soleil-related-swatch');if(icon&&source)icon.style.cssText=source.style.cssText;
  card.querySelectorAll('[data-related-link]').forEach(a=>a.href=option.dataset.url);
  {const rp=card.querySelector('.soleil-related-card__price');if(option.dataset.was)rp.innerHTML='<span class="sp-pm"><s>'+option.dataset.was+'</s> <b>'+option.dataset.price+'</b></span>';else rp.textContent=option.dataset.price;}
  picker.querySelectorAll('.soleil-related-option').forEach(el=>el.setAttribute('aria-selected',String(el===option)));
  picker.open=false;summary.focus({preventScroll:true});
 });
 document.addEventListener('keydown',event=>{
  const picker=event.target.closest('.soleil-related-picker');if(!picker)return;
  const options=Array.from(picker.querySelectorAll('.soleil-related-option'));
  if(event.key==='Escape'){picker.open=false;picker.querySelector('summary').focus();event.preventDefault();return;}
  if(!['ArrowDown','ArrowUp','Home','End'].includes(event.key))return;
  event.preventDefault();picker.open=true;
  const index=options.indexOf(document.activeElement);
  const next=event.key==='Home'?0:event.key==='End'?options.length-1:(index+(event.key==='ArrowDown'?1:-1)+options.length)%options.length;
  options[next]?.focus();
 });
})();

(() => {
 const seen=new WeakSet();
 const parse=text=>{
  text=text.replace(/[.,]00(?=([^\d]|$))/g,'');
  const match=text.match(/[\d][\d,.\s]*/);if(!match)return null;
  const raw=match[0].trim(),decimal=/[.,]\d{2}$/.exec(raw),mark=decimal?.[0][0];
  const number=Number(mark?raw.slice(0,-3).replace(/\D/g,'')+'.'+raw.slice(-2):raw.replace(/\D/g,''));
  return {number,raw,mark,text,prefix:text.slice(0,match.index),suffix:text.slice(match.index+raw.length)};
 };
 const scan=()=>document.querySelectorAll('[data-product-price],.soleil-related-card__price,[data-sp-anim]').forEach(el=>{
  if(seen.has(el))return;seen.add(el);
  let previous=parse(el.textContent.trim()),value=previous?.number,frame=0,overlay=null;
  const paint=(target,text)=>{const fragment=document.createDocumentFragment();for(const char of text){if(/\d/.test(char)){const digit=document.createElement('span');digit.className='soleil-price-digit';digit.textContent=char;fragment.append(digit);}else fragment.append(document.createTextNode(char));}target.replaceChildren(fragment);};
  let wrap=el.parentElement;
  if(!wrap?.classList.contains('soleil-price-motion')){paint(el,el.textContent.trim());wrap=document.createElement('span');wrap.className='soleil-price-motion';el.before(wrap);wrap.append(el);}
  new MutationObserver(()=>{
   const next=parse(el.textContent.trim());if(!next||next.text===previous?.text)return;
   paint(el,next.text);const from=value??previous?.number??next.number;previous=next;cancelAnimationFrame(frame);overlay?.remove();el.style.removeProperty('opacity');
   if(from===next.number||matchMedia('(prefers-reduced-motion: reduce)').matches){value=next.number;return;}
   overlay=document.createElement('span');overlay.className='soleil-price-counter';overlay.setAttribute('aria-hidden','true');const appearance=getComputedStyle(el);overlay.style.textAlign=getComputedStyle(wrap).textAlign;['font-family','font-size','font-weight','font-style','line-height','letter-spacing','color','font-variant-numeric'].forEach(p=>overlay.style.setProperty(p,appearance.getPropertyValue(p),'important'));wrap.append(overlay);const priceBox=el.getBoundingClientRect(),wrapBox=wrap.getBoundingClientRect();overlay.style.inset='auto';overlay.style.left=(priceBox.left-wrapBox.left)+'px';overlay.style.top=(priceBox.top-wrapBox.top)+'px';overlay.style.width=priceBox.width+'px';overlay.style.textAlign=getComputedStyle(wrap).textAlign;el.style.opacity='0';
   const duration=850,start=performance.now(),whole=true;
   const format=n=>{
    const text=n.toFixed(0),parts=text.split('.');
    const group=next.mark===','?'.':',';
    if(/[,.\s]/.test(next.raw.slice(0,next.mark?-3:undefined)))parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,group);
    return next.prefix+parts.join(next.mark||'.')+next.suffix;
   };
   const tick=now=>{
    const t=Math.min(1,(now-start)/duration),eased=1-Math.pow(1-t,4);
    value=from+(next.number-from)*eased;
    const display=whole?Math.round(value):Math.round(value*100)/100;
    paint(overlay,format(display));
    if(t<1&&el.isConnected)frame=requestAnimationFrame(tick);else{value=next.number;overlay.remove();overlay=null;el.style.removeProperty('opacity');}
   };tick(start);
  }).observe(el,{childList:true,subtree:true,characterData:true});
 });
 let queued=false;const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;scan();});};
 const start=()=>{scan();new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
(() => {
 const states=new Map();
 const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
 const motion=(detail,show)=>{
  const state=states.get(detail),panel=detail.querySelector(':scope > .site-nav__dropdown');if(!panel)return;
  state.animation?.cancel();state.closing=!show;
  if(reduced()){if(!show)detail.open=false;return;}
  state.animation=panel.animate(show?[{filter:'opacity(0)',translate:'0 -8px'},{filter:'opacity(1)',translate:'0 0'}]:[{filter:'opacity(1)',translate:'0 0'},{filter:'opacity(0)',translate:'0 -8px'}],{duration:280,easing:'cubic-bezier(.22,.61,.36,1)',fill:'both'});
  const current=state.animation;current.finished.then(()=>{if(state.animation!==current)return;if(!show)detail.open=false;current.cancel();state.animation=null;state.closing=false;}).catch(()=>{});
 };
 document.querySelectorAll('.site-nav__details').forEach(detail=>{
  states.set(detail,{animation:null,closing:false});
  new MutationObserver(()=>{if(detail.open)motion(detail,true);else{states.get(detail).animation?.cancel();states.get(detail).closing=false;}}).observe(detail,{attributes:true,attributeFilter:['open']});
  detail.addEventListener('mouseover',event=>{
   if(detail.contains(event.relatedTarget))return;
   states.forEach((state,other)=>{if(other!==detail&&other.open&&!state.closing)motion(other,false);});
   if(states.get(detail).closing)motion(detail,true);
  },true);
  detail.addEventListener('mouseleave',event=>{if(event.target!==detail)return;event.stopImmediatePropagation();if(detail.open&&!detail.matches(':focus-within'))motion(detail,false);},true);
 });
})();
(() => {
 const watched=new WeakSet();
 const rates={'10642699485503:10349861437759':20,'10342099091775:10529517895999':10};
 const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:document.querySelector('[data-soleil-currency]')?.dataset.soleilCurrency||'USD',minimumFractionDigits:0,maximumFractionDigits:2}).format(cents/100);
 const scan=()=>document.querySelectorAll('section-store--product-addons-block,section-store--addons-block--selector-options').forEach(host=>{
  const root=host.shadowRoot;if(!root)return;
  const sync=()=>{
   const main=document.querySelector('.product-single__meta')?.closest('[data-product-id]')?.dataset.productId||host.closest('[data-product-id]')?.dataset.productId;
   root.querySelectorAll('.addons-box').forEach(box=>{
    const rate=rates[main+':'+box.dataset.productId],subtitle=box.querySelector('.product-subtitle');if(!rate||!subtitle)return;
    const cents=Number(box.dataset.variantPrice);if(!Number.isFinite(cents))return;
    let price=subtitle.querySelector('.soleil-offer-price');if(!price){price=document.createElement('span');price.className='soleil-offer-price';subtitle.append(price);}
    subtitle.classList.add('soleil-offer-applied');
    const html='<del>'+money(cents)+'</del> <strong>'+money(Math.round(cents*(100-rate)/100))+'</strong>';
    if(price.innerHTML!==html)price.innerHTML=html;
   });
   root.querySelectorAll('.option[data-price-cents]').forEach(option=>{
    const rate=rates[main+':'+host.dataset.productId];if(!rate)return;
    const holder=option.querySelector('.variant-price');if(!holder)return;
    const cents=Number(option.dataset.priceCents),html='<del>'+money(cents)+'</del> <strong>'+money(Math.round(cents*(100-rate)/100))+'</strong>';
    if(holder.innerHTML!==html)holder.innerHTML=html;
   });
  };
  if(!watched.has(root)){
   watched.add(root);const style=document.createElement('style');style.textContent='.soleil-offer-applied>.price,.soleil-offer-applied>.original-price{display:none!important}.soleil-offer-price,.variant-price{display:flex;gap:8px;align-items:center}.soleil-offer-price del,.variant-price del{color:#929292;font-size:12px}.soleil-offer-price strong,.variant-price strong{color:#eee;font-weight:600}';root.append(style);
   let queued=false;new MutationObserver(()=>{if(queued)return;queued=true;queueMicrotask(()=>{queued=false;sync();});}).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['data-variant-price','data-variant-id']});
  }
  sync();
 });
 let queued=false;const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;scan();});};
 const start=()=>{scan();new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();(() => {
 document.addEventListener('click',event=>{
  const summary=event.target.closest('.site-nav__details > summary');
  if(summary&&(summary.textContent.trim()==='Help'||summary.hasAttribute('data-soleil-bike-menu'))){event.preventDefault();event.stopImmediatePropagation();summary.parentElement.open=true;}
 },true);
})();

(() => {
 const setup=()=>document.querySelectorAll('.soleil-collection-preview').forEach(card=>{
  if(card.dataset.peekReady)return;card.dataset.peekReady='true';const details=card.querySelector('details');if(!details)return;
  let timer;card.addEventListener('mouseenter',()=>{if(!matchMedia('(min-width:769px) and (hover:hover)').matches)return;clearTimeout(timer);details.open=true;});
  card.addEventListener('mouseleave',()=>{timer=setTimeout(()=>{if(!details.contains(document.activeElement))details.open=false;},140);});
  card.addEventListener('keydown',event=>{if(event.key==='Escape'){details.open=false;card.querySelector('a').focus();}});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();document.addEventListener('shopify:section:load',setup);
})();
(() => {
 const styles=`.loox-video-slider-widget{font-family:var(--typeBasePrimary),sans-serif!important;--loox-video-slider-computed-padding-top:16px!important;--loox-video-slider-computed-padding-bottom:24px!important}
 .video-slide{border:1px solid #343434!important;border-radius:0!important;overflow:hidden;background:#111!important;transition:border-color 220ms,box-shadow 220ms}
 .video-slide:hover{border-color:#666!important;box-shadow:0 0 20px #ffffff10}
 .review-detail{padding:36px 16px 16px!important;background:linear-gradient(transparent,#080808ed)!important;text-align:left!important}
 .reviewer-name{font-family:var(--typeHeaderPrimary),sans-serif!important;font-weight:700!important;font-size:16px!important;color:#f7f7f7!important}
 .rating{color:#f5c542!important;animation:soleil-star-glow 3.8s ease-in-out infinite}
 @keyframes soleil-star-glow{0%,100%{filter:drop-shadow(0 0 1px #f5c54230)}50%{filter:drop-shadow(0 0 4px #f5c54280)}}
 .navigation-button{background:#151515!important;color:#f7f7f7!important;border:1px solid #555!important;border-radius:0!important;box-shadow:0 3px 12px #0006;transition:transform 200ms,background 200ms}
 .navigation-button:hover{transform:scale(1.06);background:#252525!important}
 .slide-play-icon button{background:#111b!important;border:1px solid #ffffff80!important;backdrop-filter:blur(4px);transition:transform 200ms,box-shadow 200ms}
 .slide-play-icon button:hover{transform:scale(1.08);box-shadow:0 0 18px #ffffff30}
 @media(max-width:767px){.swiper-slide,.viewport{max-height:320px!important}.video-slide,.slide-stage,.swiper-slide-inner{height:320px!important;max-height:320px!important}.reviewer-name{font-size:14px!important}.review-detail{padding:30px 12px 14px!important}.navigation-button{width:42px!important;height:42px!important}}
 @media(prefers-reduced-motion:reduce){.video-slide,.navigation-button,.slide-play-icon button{transition:none!important}.rating{animation:none!important}}`;
 const setup=()=>document.querySelectorAll('loox-video-slider-widget').forEach(host=>{const root=host.shadowRoot;if(!root||root.querySelector('#soleil-video-style'))return;const style=document.createElement('style');style.id='soleil-video-style';style.textContent=styles;root.append(style);});
 customElements.whenDefined('loox-video-slider-widget').then(()=>{setup();let tries=0;const timer=setInterval(()=>{setup();if(++tries>=20)clearInterval(timer);},500);});document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

})();
